import React from 'react'
import RewardChart from '../../../resources/analytics/reward-chart'

const AnalyticsEtherReward = () => {
    return (
        <div>
            <div className="py-3 mb-2">
                <RewardChart/>
            </div>
        </div>
    )
}

export default AnalyticsEtherReward